import de from "./i18n/dicts/de.js";
import en from "./i18n/dicts/en.js";
import uk from "./i18n/dicts/uk.js";
import fr from "./i18n/dicts/fr.js";
import nl from "./i18n/dicts/nl.js";
import pl from "./i18n/dicts/pl.js";
import it from "./i18n/dicts/it.js";
import da from "./i18n/dicts/da.js";
import es from "./i18n/dicts/es.js";
import no from "./i18n/dicts/no.js";

export const SUPPORTED_LANGS = [
  "de",
  "en",
  "uk",
  "fr",
  "nl",
  "pl",
  "it",
  "da",
  "es",
  "no",
];

export const DICTS = {
  de,
  en,
  uk,
  fr,
  nl,
  pl,
  it,
  da,
  es,
  no,
};

const STORAGE_KEY = "lang";

export function normalizeLang(lang, fallback = "de") {
  const code = String(lang || "").trim().toLowerCase();
  return SUPPORTED_LANGS.includes(code) ? code : fallback;
}

export function getInitialLang() {
  if (typeof window !== "undefined") {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (SUPPORTED_LANGS.includes(saved)) return saved;
    } catch {}
  }

  return "de";
}

let currentLang = getInitialLang();

export function setGlobalLang(lang) {
  currentLang = normalizeLang(lang, "de");

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, currentLang);
    } catch {}
  }
}

export function getCurrentLang() {
  return currentLang;
}

export function t(key, fallback) {
  const dict = DICTS[currentLang] || DICTS.de || {};

  if (Object.prototype.hasOwnProperty.call(dict, key)) {
    return dict[key];
  }

  return fallback !== undefined ? fallback : key;
}

export function tLang(key, lang = currentLang, fallback) {
  const safeLang = normalizeLang(lang, "de");
  const dict = DICTS[safeLang] || DICTS.de || {};

  if (Object.prototype.hasOwnProperty.call(dict, key)) {
    return dict[key];
  }

  return fallback !== undefined ? fallback : key;
}

// ✅ formatted translation
// приклад:
// tf("cart.deposit.badge", { amount: 20 }, "Deposit {amount}€", "de")
export function tf(key, vars = {}, fallback, lang = currentLang) {
  const text = tLang(key, lang, fallback);

  if (!vars || typeof vars !== "object") {
    return text;
  }

  return String(text).replace(/\{(\w+)\}/g, (match, name) => {
    const value = vars[name];

    if (value === undefined || value === null) {
      return match;
    }

    return String(value);
  });
}

export function localizeValue(value, lang = currentLang, fallback = "") {
  const safeLang = normalizeLang(lang, "de");

  if (typeof value === "string") return value;

  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return fallback;
  }

  return (
    value[safeLang] ||
    value[safeLang.toUpperCase()] ||
    value.de ||
    value.en ||
    fallback
  );
}